import React, { useEffect, useState } from 'react'
import { Container } from 'reactstrap';
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Row, Col } from 'reactstrap'
import { MaterialReactTable } from 'material-react-table';
import { ToastContainer, toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOrders } from '../../slices/orderManagement/thunk';
import { Loader } from '../Utils/Loader';
import { orderData } from './constants/OrderData';
import { OrderListColumns } from './constants/OrderManagementTableColumns';
import { MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { setDeleteSuccessMessage, setSuccessMessage } from '../../slices/toastMessage/action';
import { PAGE_TITLES } from '../Common/constants';
import { createdByFunction, namedArrayFunction, taxIncludedAmountFunctions } from './constants/OrderListingFunctions';
import { useColumnSettings } from '../Utils/useColumnSettings';
import { getView } from '../../slices/View/thunk';
import { hasPermission } from '../Utils/UtilityFunctions';

function OrderListing() {

    const orderDataArray = [];
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const rawPermissions = useSelector(
        (state) => state.permissions.permissionsMap
    );

    const permissionsMap = new Map(
        rawPermissions.map(([key, value]) => [key, new Set(value)])
    );
    const orderPermission = hasPermission(permissionsMap, "customer", "order")
    const viewPermission = hasPermission(permissionsMap, "miscellaneous", "view")

    useEffect(() => {
        dispatch(fetchOrders(setLoading))
        dispatch(getView(setLoading));
    }, [dispatch])

    const order = useSelector((state) => state.OrderList.orders)
    const taxIncludedValues = taxIncludedAmountFunctions(order)
    let createdBy = createdByFunction(order)
    let namesArray = namedArrayFunction(order)

    const orderList = orderData(order, orderDataArray, taxIncludedValues, namesArray, createdBy)
    const columns = OrderListColumns()
    const showSuccessMessage = useSelector((state) => state.SuccessToast.showSuccessMessage)
    const showDeleteMessage = useSelector((state) => state.SuccessToast.showDeleteSuccessMessage)

    useEffect(() => {
        if (showSuccessMessage) {
            toast.success(`Order Placed Successfully. Payment link has been sent to your mail`);
            dispatch(setSuccessMessage(false))
        }
        if (showDeleteMessage) {
            toast.success(`Order Cancelled Successfully`);
            dispatch(setDeleteSuccessMessage(false))
        }
    }, [showSuccessMessage, showDeleteMessage, dispatch]);

    const {
        settingsModalOpen,
        viewColumns,
        toggleSettingsModal,
        SettingsSidebar
    } = useColumnSettings('order', columns);

    const operatorConfiguration = useSelector((state) => state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration)

    const isEIPEnabled = operatorConfiguration?.configurations?.EIP?.value?.Enabled?.value === true;

    const customerListTitle = isEIPEnabled
        ? PAGE_TITLES.CUSTOMER_LIST_EIP
        : PAGE_TITLES.CUSTOMER_LIST;

    return (
        <React.Fragment>
            {loading && (<Loader />)}
            <div id='csms' className='page-content bg-white pb-0 mb-0'>
                <Container fluid>
                    <BreadCrumb title={PAGE_TITLES.CUSTOMER_ORDER} pageTitle={customerListTitle} />
                    <ToastContainer position='top-center' />
                    <h5 className="p-2">Order List</h5>
                    <Row className="d-flex align-items-sm-start border mx-2 mb-5">
                        <Col lg={settingsModalOpen ? 10 : 12} className="border">
                            <div className="container-fluid px-0">
                                <div className="disable-margin-card w-100">
                                    <Row className="mb-3 table-responsive">
                                        {orderList ?
                                            <MaterialReactTable
                                                columns={columns.filter((column) => viewColumns?.includes(column.accessorKey || column.header))}
                                                data={orderList}
                                                enableColumnOrdering
                                                enableColumnActions={true}
                                                enableColumnDragging={false}
                                                enableRowActions
                                                enableDensityToggle={false}
                                                enableTopToolbar={false}
                                                initialState={{
                                                    columnVisibility: {
                                                        'id': false,
                                                    },
                                                }}
                                                icons={{
                                                    DragHandleIcon: () => <i className="ri-drag-move-fill" />,
                                                }}
                                                displayColumnDefOptions={{
                                                    'mrt-row-actions': {
                                                        header: '',
                                                        enableHiding: true,
                                                        size: 52,
                                                        grow: true
                                                    },
                                                }}
                                                defaultColumn={{
                                                    minSize: 10,
                                                    maxSize: 9001,
                                                    muiTableBodyCellProps: {
                                                        sx: {
                                                            fontFamily: "Inter,sans-serif"
                                                        }
                                                    },
                                                    muiTableHeadCellProps: {
                                                        sx: {
                                                            fontFamily: "Inter,sans-serif"
                                                        }
                                                    }
                                                }}
                                                renderTopToolbarCustomActions={() => (
                                                    <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between w-100">
                                                        <div className="d-flex flex-column flex-md-row">
                                                        </div>
                                                        {viewPermission && viewPermission?.has("view") &&
                                                            <div className="d-flex align-items-center">
                                                                <div color="secondary" className="btn-icon me-2 cursor-img" onClick={toggleSettingsModal}>
                                                                    <i className="ri-settings-2-line fs-4"></i>
                                                                </div>
                                                            </div>}
                                                    </div>
                                                )}
                                                renderRowActionMenuItems={({ row, closeMenu }) =>
                                                    [
                                                        orderPermission && orderPermission?.has('view') ? <MenuItem key={`${row.index}.1`} onClick={() => {
                                                            navigate(`/view-order/${row.original.id}`)
                                                        }}><  i className='ri-account-circle-line me-2' /> View</MenuItem> : null,
                                                        row.original.state === "pending" && (orderPermission && orderPermission?.has('delete')) ? <MenuItem key={`${row.index}.2`} onClick={() => { navigate(`/cancel-order/${row.original.id}`) }}><  i className='ri-delete-bin-5-line me-2' /> Cancel</MenuItem> : null
                                                    ]
                                                }
                                            />
                                            : null
                                        }
                                    </Row>
                                </div>
                            </div>
                        </Col>
                        {SettingsSidebar()}
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}
export default OrderListing;